// App/deployment version metadata (#539). Values are injected at build
// time by vite.config.ts (see __APP_VERSION__ / __GIT_SHA__ globals) so
// the same build reports the same version across every deployed tenant.
// Feature flags are NOT part of this — see useTenantConfig for those.
export const APP_VERSION = __APP_VERSION__;
export const GIT_SHA = __GIT_SHA__;
export const FULL_VERSION = `${APP_VERSION}+${GIT_SHA}`;
